import React from 'react'
import  './Textarea.scss';


const Textarea = props => {
    let propsNew = {...props};
    // id можно задать явно — см. комментарий в Input.js про дубли id.
    propsNew.id = props.id || props.name;

    let hasError = false;

    if (props.hasOwnProperty('errors') && props.errors.hasOwnProperty(props.name) && props.errors[props.name]) {
        propsNew.className += ' invalid';
        hasError = true;
    }

    return (
        <div className={`Textarea ${propsNew.className}`}>
            <label htmlFor={propsNew.id}>
                {propsNew.label}
                {hasError ? (<i className="icon-alert-triangle error-icon"></i>) : ''}
            </label>
            <textarea {...propsNew}>{propsNew.children}</textarea>
        </div>
    )
};

export default Textarea
